import { render, staticRenderFns } from "./WinnersModal.vue?vue&type=template&id=2ec1dcb1&scoped=true&"
import script from "./WinnersModal.vue?vue&type=script&lang=js&"
export * from "./WinnersModal.vue?vue&type=script&lang=js&"
import style0 from "./WinnersModal.vue?vue&type=style&index=0&id=2ec1dcb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec1dcb1",
  null
  
)

export default component.exports